import { render, staticRenderFns } from "./ProjectsHint.vue?vue&type=template&id=1b89affb&scoped=true"
import script from "./ProjectsHint.vue?vue&type=script&lang=js"
export * from "./ProjectsHint.vue?vue&type=script&lang=js"
import style0 from "./ProjectsHint.vue?vue&type=style&index=0&id=1b89affb&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b89affb",
  null
  
)

export default component.exports